//let type = process.env.REACT_APP_ENV;
// console.log ('type',process.env.REACT_APP_ENV);
//fix 服务器环境区分
let origin = window.location.origin;
let type = 'prod';
// console.log ("origin....",origin);
if (origin.indexOf('gallery-fat.vphotos.cn') >= 0) {
	type = 'fat';
} else if (origin.indexOf('gallery-fat-1.vphotos.cn') >= 0) {
	type = 'fat1';
} else if (origin.indexOf('gallery.vphotos.cn') >= 0 || origin.indexOf('toutube.vphotos.cn') >= 0 || origin.indexOf('toutube.cn') >= 0) {
	type = 'prod';
} else if (origin.indexOf('gallery-uat-1.vphotos.cn') >= 0) {
	type = 'uat1';
} else {
	type = 'uat1';//uat1
//	type = 'fat';//fat
}
let { API } = require(`./${type}`);
console.log('project path...', API);
export { API, type as ENV_TYPE };
